import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { List } from 'immutable';

import { Table, TableRow, TableCell, TableBody } from '@comparethemarketau/manor-table';

import { RemoveButton } from '../common/remove_button';
import { ProductIntroCardTitle } from '../common/product_intro_card_title';
import { ProductIntroCardPrice } from '../common/product_intro_card_price';
import { ProductIntroCardTouch } from '../common/product_intro_card_touch';

const useStyles = createUseStyles((theme) => ({
    container: {
    },
    productTable: {
        background: theme.colors.grey100
    },
    cell: {
        padding: 0
    },
    productCell: {
        background: theme.colors.white,
        borderColor: theme.colors.grey300,
        borderStyle: 'solid',
        borderWidth: '0 0.1rem 0 0'
    }
}));

const ComparingProductsIntro = (props) => {
    const { selectedProducts, cellClassName, isShowRemoveButtons, stackDisplayMode } = props;

    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classNames('test-policyComparison-comparingProductsIntro', classes.container)}>
            {
                isShowRemoveButtons && (
                    <Table ariaLabel="Comparing products remove buttons" ariaDescribedby="remove-buttons">
                        <TableBody>
                            <TableRow>
                                {
                                    !stackDisplayMode && <TableCell className={classNames(classes.cell, cellClassName)} key="RemoveButton-spacer" />
                                }
                                {
                                    selectedProducts.map((product) => {
                                        return (
                                            <TableCell align="center" className={classNames(classes.cell, cellClassName)} key={`RemoveButton-${getProductId(product)}`}>
                                                <RemoveButton productId={getProductId(product)} />
                                            </TableCell>
                                        );
                                    })
                                }
                            </TableRow>
                        </TableBody>
                    </Table>
                )
            }
            <Table ariaLabel="Comparing products table" ariaDescribedby="product-table" className={classes.productTable}>
                <TableBody>
                    <TableRow>
                        {
                            !stackDisplayMode && <TableCell className={classNames(classes.cell, cellClassName)} key="ProductIntroCardTitle-spacer" />
                        }
                        {
                            selectedProducts.map((product) => {
                                return (
                                    <TableCell
                                        align="center"
                                        className={classNames(classes.productCell, classes.cell, cellClassName)}
                                        key={`ProductIntroCardTitle-${getProductId(product)}`}
                                    >
                                        <ProductIntroCardTitle quote={product} />
                                    </TableCell>
                                );
                            })
                        }
                    </TableRow>
                    <TableRow>
                        {
                            !stackDisplayMode && <TableCell className={classNames(classes.cell, cellClassName)} key="ProductIntroCardPrice-spacer" />
                        }
                        {
                            selectedProducts.map((product) => {
                                return (
                                    <TableCell
                                        align="center"
                                        className={classNames(classes.productCell, classes.cell, cellClassName)}
                                        key={`ProductIntroCardPrice-${getProductId(product)}`}
                                    >
                                        <ProductIntroCardPrice quote={product} />
                                    </TableCell>
                                );
                            })
                        }
                    </TableRow>
                </TableBody>
            </Table>
            <Table ariaLabel="Products get in touch buttons" ariaDescribedby="get-in-touch-buttons" className={classes.productTable}>
                <TableBody>
                    <TableRow>
                        {
                            !stackDisplayMode && <TableCell className={classNames(classes.cell, cellClassName)} key="ProductIntroCardTouch-spacer" />
                        }
                        {
                            selectedProducts.map((product) => {
                                return (
                                    <TableCell
                                        align="center"
                                        className={classNames(classes.productCell, classes.cell, cellClassName)}
                                        key={`ProductIntroCardTouch-${getProductId(product)}`}
                                    >
                                        <ProductIntroCardTouch quote={product} />
                                    </TableCell>
                                );
                            })
                        }
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    );
};

ComparingProductsIntro.propTypes = {
    selectedProducts: PropTypes.instanceOf(List),
    cellClassName: PropTypes.string,
    stackDisplayMode: PropTypes.bool,
    isShowRemoveButtons: PropTypes.bool
};

const STICKY_TOPPEST_COMPONENT_CLASSNAME = 'test-policyComparison-productsIntro';

const getProductId = (product) => {
    return product.getIn(['productMeta', 'id']);
};

export { ComparingProductsIntro, STICKY_TOPPEST_COMPONENT_CLASSNAME, getProductId };
